import script from "./ConfigurationPackageSelectionOptional.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationPackageSelectionOptional.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationPackageSelectionOptional.vue?vue&type=style&index=0&id=5eff9a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eff9a76"]])

export default __exports__